<template>
  <div>
    <b-modal
      id="modalAccident2"
      title="สรุปจำนวนเหตุการณ์ (สายทาง)"
      size="lg"
      ok-title="กลับ"
      ok-only
    >
      <b-row class="text3">
        <b-col
          class="d-flex align-items-center justify-content-end"
          lg="12"
        >
          <span
            class="ml-5"
            style="font-size: 14px; color: #ffffff;"
          >ข้อมูลวันที่:</span>
          <b-form-group class="ml-1">
            <flat-pickr
              v-model="date_from"
              style="background-color:rgba(0, 0, 0, 0.6); color:#ffffff; border-color: rgba(180, 180, 180, 0.326);"
              class="form-control"
              @input="getPopupAnalyticDB()"
            />
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <b-table
            responsive
            :per-page="perPage"
            :items="items"
            :fields="fields"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            :filter="filter"
            :filter-included-fields="filterOn"
            :borderless="borderless"
          >
            <template #cell(detail)="data">
              <b-link
                v-b-modal="'modalAnalytic'"
                title="กดเพื่อดูเพิ่มเติม"
                style="color: #11DF00;"
                @click="$refs.childref.getModalTableAnalytic(data.item.WID ,items1[data.index].detail)"
              >
                <u>{{ items1[data.index].detail }}</u>
              </b-link>
            </template>
            <template #cell(Total)="data">
              {{ data.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }} ครั้ง
            </template>
            <template #cell(Total_CarStop)="data">
              {{ data.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }} คัน
            </template>
            <template #cell(Total_WrongWay)="data">
              {{ data.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }} คัน
            </template>
          </b-table>
        </b-col>
      </b-row>
      <ModalAnalytic
        ref="childref"
      />
    </b-modal>
  </div>
</template>

<script>
import {
  BRow, BCol, BTable, BLink, BFormGroup,
} from 'bootstrap-vue'
import axios from '@axios'
import flatPickr from 'vue-flatpickr-component'
import ModalAnalytic from '@/views/dashboard/modal/ModalAnalytic.vue'

export default {
  components: {
    BRow,
    BCol,
    BTable,
    BLink,
    BFormGroup,
    flatPickr,
    ModalAnalytic,
  },
  data() {
    return {
      date_from: '',

      fields: [
        {
          key: 'detail',
          label: 'สายทาง',
          sortable: false,
        },
        {
          key: 'Total',
          label: 'เหตุการณ์ทั้งหมด',
          sortable: false,
          class: 'text-center',
          tdClass: 'bg-light-warning',
        },
        {
          key: 'Total_CarStop',
          label: 'รถหยุด',
          sortable: false,
          class: 'text-center',
          tdClass: 'bg-light-danger',
        },
        {
          key: 'Total_WrongWay',
          label: 'รถย้อนศร',
          class: 'text-center',
          tdClass: 'bg-light-info',
        },
      ],
      items: [],
      items1: [],
      perPage: 1000,
      sortBy: '',
      sortDesc: false,
      borderless: true,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],

      userData: JSON.parse(localStorage.getItem('userData')),
    }
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
    computedFields() {
      // If the user isn't an admin, filter out fields that require auth.
      if (this.userData.role === 'User') return this.fields.filter(field => !field.requiresAdmin)
      return this.fieldsSpeaker
    },
  },

  beforeDestroy() {
    clearInterval(this.interval)
  },
  mounted() {
    this.setToday()
    this.getPopupAnalyticDB()
    this.interval = setInterval(() => {
      this.getPopupAnalyticDB()
    }, 300000)
  },
  methods: {
    getPopupAnalyticDB() {
      axios
        .post('/popupAnalyticDB', { department: this.userData.department, owner: this.userData.groupname, username: this.userData.username }, { date_from: this.date_from })
        .then(response => {
          // eslint-disable-next-line prefer-destructuring
          this.items = response.data[0]
          // eslint-disable-next-line prefer-destructuring
          this.items1 = response.data[1]
          this.totalRows = response.data.length
        })
        .catch(error => {
          console.log(error)
        })
    },
    setToday() {
      const p = new Date()
      const month = (`0${p.getMonth() + 1}`).slice(-2)
      // const date = (`0${p.getDate()}`).slice(-2)cmd
      const year = p.getFullYear()
      // this.date.dateFrom = `${year}-${month}-1`
      const dateTo = (`0${p.getDate()}`).slice(-2)
      this.date_from = `${year}-${month}-${dateTo}`
    },
    // getPopupAnalyticDB() {
    //   axios
    //     .post('/popupAnalyticDB', { department: this.userData.department })
    //     .then(response => {
    //       this.event = response.data
    //       this.Total = []
    //       this.TotalCarStop = []
    //       this.TotalWrongWay = []
    //       this.Detail = []
    //       this.event.forEach(value => {
    //         this.Detail.push(value.detail)
    //         this.Total.push(value.Total)
    //         this.TotalCarStop.push(value.Total_CarStop.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))
    //         this.TotalWrongWay.push(value.Total_WrongWay.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))
    //       })
    //     })
    //     .catch(error => {
    //       console.log(error)
    //     })
    // },
  },
}
</script>

<style lang="scss" scoped>
.text3 {
    font-family: 'Sarabun';
    font-size: 16px;
    color: #fff;
  }
</style>
